import { ExpiryMethodApi } from '@voladeum/client';
import { VoladeumResponse } from 'client/types';

import { Axios } from '../../axios';

import { normalizeExpiryMethods } from './normalizers';
import { ExpiryMethod } from './types';

export class VoladeumExpiryMethods extends Axios {
  async list(): Promise<VoladeumResponse<ExpiryMethod[]>> {
    const res = await this.get<VoladeumResponse<ExpiryMethodApi[]>>('/v1/lookups/expiry-methods');
    return {
      success: res.success,
      error: res.error,
      data: normalizeExpiryMethods(res.data),
    };
  }
}
